"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    root: {
      // This color and opacity are fixed by design system
      color: '#343B45',
      opacity: '25%',
      height: 0,
      borderStyle: 'solid none none',
      margin: 0
    },
    fullWidth: {
      width: '100%'
    }
  };
};

var HorizontalRule = function HorizontalRule(props, ref) {
  var fullWidth = props.fullWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["fullWidth"]);
  var classes = useStyles();
  return (0, _core.jsx)("hr", (0, _extends2.default)({
    ref: ref,
    css:
    /*#__PURE__*/
    (0, _css2.default)([classes.root, fullWidth && classes.fullWidth], ";label:HorizontalRule;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ib3Jpem9udGFsUnVsZS9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJ1QiIsImZpbGUiOiIuLi8uLi9zcmMvSG9yaXpvbnRhbFJ1bGUvaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIEhUTUxQcm9wcywgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGludGVyZmFjZSBIb3Jpem9udGFsUnVsZVByb3BzIGV4dGVuZHMgSFRNTFByb3BzPEhUTUxIUkVsZW1lbnQ+IHtcbiAgZnVsbFdpZHRoPzogYm9vbGVhbjtcbn1cblxuY29uc3QgdXNlU3R5bGVzID0gKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHJvb3Q6IHtcbiAgICAgIC8vIFRoaXMgY29sb3IgYW5kIG9wYWNpdHkgYXJlIGZpeGVkIGJ5IGRlc2lnbiBzeXN0ZW1cbiAgICAgIGNvbG9yOiAnIzM0M0I0NScsXG4gICAgICBvcGFjaXR5OiAnMjUlJyxcbiAgICAgIGhlaWdodDogMCxcbiAgICAgIGJvcmRlclN0eWxlOiAnc29saWQgbm9uZSBub25lJyxcbiAgICAgIG1hcmdpbjogMCxcbiAgICB9LFxuICAgIGZ1bGxXaWR0aDoge1xuICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICB9LFxuICB9IGFzIGNvbnN0O1xufTtcblxuY29uc3QgSG9yaXpvbnRhbFJ1bGU6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8SFRNTEhSRWxlbWVudCwgSG9yaXpvbnRhbFJ1bGVQcm9wcz4gPSAocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7IGZ1bGxXaWR0aCwgLi4ub3RoZXIgfSA9IHByb3BzO1xuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIDxociByZWY9e3JlZn0gY3NzPXtbY2xhc3Nlcy5yb290LCBmdWxsV2lkdGggJiYgY2xhc3Nlcy5mdWxsV2lkdGhdfSB7Li4ub3RoZXJ9IC8+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihIb3Jpem9udGFsUnVsZSk7XG4iXX0= */"))
  }, other));
};

__signature__(HorizontalRule, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(HorizontalRule);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
  reactHotLoader.register(HorizontalRule, "HorizontalRule", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/HorizontalRule/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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